export enum PaymentType {
  None = 0,
  NoShow = 1,
  PrePayment = 2,
}
